import {FormRuleType} from '../../../../../../service/form/form-rules-hook-type';
import {YandexStorySlideType} from '../../../../../../service/yandex-stories/yandex-stories-type';
import {isValidUrl} from '../../../../../../util/url';

export const YANDEX_STORY_MAX_BUTTON_TEXT_LENGTH = 15;
export const YANDEX_STORY_MAX_BUTTON_LINK_LENGTH = 300;

// The first slide that cannot be submitted: its upload failed, or its button is half-filled. Button
// fields only exist for the previewed slide, so they are checked here instead of by a form rule.
export function findInvalidYandexStorySlide(slides: Array<YandexStorySlideType>): YandexStorySlideType | undefined {
    return slides.find((slide) => {
        if (slide.status !== 'done') {
            return true;
        }

        if (!slide.buttonConfig) {
            return false;
        }

        const {text, link} = slide.buttonConfig;

        return !(text.trim() && text.length <= YANDEX_STORY_MAX_BUTTON_TEXT_LENGTH && link.trim() && isValidUrl(link));
    });
}

// Required fields of the story step: its name and, on every slide that carries a button, that
// button's text and link. Length limits are left to the inputs and the form rules — a name that is
// too long can only come from a translated default, and locking the submit over it would be worse
// than the rule that reports it.
export function isYandexStoryFormFilled(name: string | undefined, slides: Array<YandexStorySlideType>): boolean {
    if (!name?.trim()) {
        return false;
    }

    return !findInvalidYandexStorySlide(slides);
}

// The rule sits on a hidden field, so its message never reaches the screen — but a rejection without
// one leaves `validateFields` failing silently. The submit button is blocked for the same reason and
// explains itself in a tooltip; this stays as the guard behind it.
export function validateYandexStorySlideImage(message: string): FormRuleType<YandexStorySlideType> {
    return {
        validator: (_rule: unknown, value: YandexStorySlideType): Promise<void> => {
            if (value.status === 'done') {
                return Promise.resolve();
            }

            return Promise.reject(new Error(message));
        },
    };
}
